import { Link } from 'react-router-dom';
import Loading from './loading';
import React from 'react';
import { selectSession } from '../redux/slices/sessionSlice';
import { useAppSelector } from '../redux/hook';

export const LightTNCCard = ({
	logo,
	content,
	loading,
	isStatic,
	contentPP,
	logoPP,
}) => {
	const { loading: toastLoading, propertyInfo } = useAppSelector(selectSession);
	const hotelName = propertyInfo?.propertyName ?? '';
	if (isStatic === false) {
		return loading || toastLoading ? (
			<Loading />
		) : (
			content?.length > 0 && (
				<div
					className="w-100 mx-auto p-2 d-flex flex-column"
					style={{
						maxWidth: '1200px',
						overflow: 'auto',
						maxHeight: '60vh',
					}}>
					<div
						className="overflow-auto bg-white p-3 rounded-3 w-100 flex-grow-1"
						style={{
							border: 'solid 1px #00000042',
						}}>
						<div className="w-100">
							{content?.map((item, index) => (
								<p
									style={{
										fontSize: '12px',
										textJustify: 'inter-word',
										textAlign: 'justify',
										whiteSpace: 'pre-wrap',
									}}
									className="w-100 m-0 lh-sm"
									key={index}
									dir={item.direction?.toLowerCase() ?? 'ltr'}>
									{item.content}
								</p>
							))}
						</div>
					</div>
				</div>
			)
		);
	} else {
		return loading || toastLoading ? (
			<Loading />
		) : (
			<div
				className="w-100 mx-auto p-2 d-flex flex-column"
				style={{
					maxWidth: '1200px',
					overflow: 'auto',
					maxHeight: '60vh',
				}}>
				<div
					className="overflow-auto bg-white p-3 rounded-3 w-100 flex-grow-1"
					style={{
						border: 'solid 1px #00000042',
					}}>
					<div className="w-100">
						{content?.map((item, index) => (
							<p
								style={{
									fontSize: '12px',
									textJustify: 'inter-word',
									textAlign: 'justify',
									whiteSpace: 'pre-wrap',
								}}
								className="w-100 m-0 lh-sm"
								key={index}
								dir={item.direction?.toLowerCase() ?? 'ltr'}>
								{item.content}
							</p>
						))}
					</div>

					{/*<div className="w-100">
						<p
							style={{
								fontSize: '12px',
								textJustify: 'inter-word',
								textAlign: 'justify',
								whiteSpace: 'pre-wrap',
							}}
							className="w-100 m-0 lh-sm">
							Our Privacy Policy aims to explain to you how and what data we
							collect and how and why we use your personal data. It also
							describes the choices we offer you to access, update or take
							control of your personal data that we process.
							<br />
							<b>What information does {hotelName} collect about me?</b>
							<br />
							When you use our contact forms, we collect your basic information
							such as name, address, email address and phone number. When you
							book or sign up for our loyalty programs, we may collect
							additional information, including government identification and
							credit card data. We also record information when you contact us,
							including customer service requests and notes, or details
							describing what you asked and how we responded. Although they do
							not contain your personal information, we use cookies on our
							websites and mobile applications to collect information about
							interactions and usage.
							<br />
							<b>How does {hotelName} use information about me?</b> We use
							information about you to improve, update and enhance the services
							we provide to you. For example, we use information about you to
							provide our services (such as room and restaurant reservations)
							and to detect and prevent fraud and abuse. <br />
							<b>Does {hotelName} share my data with third parties?</b>
							<br />
							We do not share your personal data with third parties unless we
							are required by local laws and/or regulations. Examples of when we
							share data include processing payments and checking into one of
							our hotels. We only share the minimum information necessary to
							perform or provide this service. <br />
							<b>
								How can I view the personal information that {hotelName} stores
								about me?
							</b>
							<br />
							You can request a copy of your personal data from us by filling
							out the form available for download here and sending it to us as
							described in this form. We will respond to your request within 30
							days by providing a link to a location where the data can be
							downloaded. <br />
							<b>How can I delete my personal information on {hotelName}?</b>
							<br />
							You can request that we delete your personal data from our records
							by filling out the form you can download here and sending it to us
							as described. However, there may be legal restrictions that
							require us to retain certain information about you for a certain
							period of time. When we receive your completed form, you will be
							informed, if possible, of such restrictions. In any case, we
							respond to your request within 30 days.
							<br />
							<b>
								What is the purpose of the Cookies you use on your websites?
							</b>
							<br />
							Cookies on our websites allow us to improve your user experience
							and track your browsing behaviour, such as links clicked, items
							purchased, your device and browser type, your geolocation, etc.
							This enables us to provide you with more relevant product
							offerings, a better experience on our websites, and to collect,
							analyze and improve the performance of our services. We do not
							share this information with third parties. For more information,
							please read our Cookie Statement.
							<br />
							<b>How will you use my email address?</b>
							<br />
							We will use your email address to communicate with you regarding
							your questions, room or restaurant reservation, and to send you
							informative email messages if you have chosen to receive
							information about upcoming events or offers at our hotels. We do
							not share your email address with third parties. You can opt out
							of receiving email communications from us at any time by using the
							links shown at the bottom of the e-mail messages we send you.
							<br />
							<b>
								Who outside of {hotelName} has access to my stored personal
								information?
							</b>
							<br />
							{hotelName} is obligated to cooperate with government and law
							enforcement authorities to enforce and comply with the laws
							applicable in the countries in which {hotelName} operates. Because
							we believe it is necessary or appropriate to respond to claims and
							legal process (such as subpoena requests), we will, in our sole
							discretion, disclose information about you to government or law
							enforcement authorities to protect our property and rights or the
							property and rights of a third party, to protect the safety of the
							public or any person, or to prevent or stop activities that we
							deem illegal, unethical. To the extent legally permissible, we
							will take reasonable steps to notify you if we are required to
							provide your personal information as part of a legal process. If
							you have additional questions about our practices or any of your
							rights described above, you can contact our Data Protection
							Officer at any time at{' '}
							<Link target="_blank" to="https://www.itc.com/privacypolicy">
								privacy@{hotelName}.com
							</Link>
						    {' '}
							or at the address shown below.
							<br />
							<br />
							{hotelName} Hotel Management
							<br />
							PO Box 95100, <br />
							India
						</p>
						</div> */}
				</div>
			</div>
		);
	}
};
